import { useAuth } from './useAuth';
import { useIsMimicking } from './useIsMimicking';
import { canUseRoary } from '../utils/roaryAccess';

/** True when the current session may use Roary UI (admins and admin mimic sessions). */
export function useCanUseRoary(): boolean {
  const { isAdmin } = useAuth();
  const isMimicking = useIsMimicking();
  return canUseRoary(isAdmin, isMimicking);
}
